module.exports = __webpack_public_path__ + "img/report-8.c5728498.jpg";